<template>
  <div class="addclient">
    <div class="card-block">
      <div class="row justify-content-center" v-if="emailAddresses.length > 0">
        <div class="col-md-12">
        </div>
        <div class="col-md-12">
          <table class="table" data-testid="registration-email-list">
            <thead>
            <tr>
              <th>E-mailová adresa</th>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <template v-for="emailAddr in emailAddresses" class="card-text">
              <tr>
                <td class="align-middle">
                  {{ emailAddr.email }}
                </td>
                <td>
                  {{ emailAddr.default === true ? 'výchozí' : '' }}
                </td>
                <td>
                  {{ emailAddr.note }}
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row justify-content-center">
        <form v-if="!waitForData" @submit.prevent="submitForm" data-testid="registration-email-form">
          <div class="form-group col-md-12">
            <div class="input-group">
              <input v-model="emailAddress.email" type="text" placeholder="e-mailová adresa" class="form-control" id="emailAddress" data-testid="registration-email-address">
              <span class="input-group-addon">
                          Výchozí:&nbsp;
                        <input v-model="emailAddress.default" type="checkbox" aria-label="Checkbox for following text input" data-testid="registration-email-default">
                      </span>
              <input v-model="emailAddress.note" type="text" class="form-control" id="emailAddressNote" data-testid="registration-email-note" placeholder="poznámka">
              <button v-if="emailAddressPending === false" type="submit" class="btn btn-primary" data-testid="registration-email-add">Přidat e-mail</button>
              <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
            </div>
            <small id="numberError" class="form-text text-danger" data-testid="registration-email-error" v-if="emailAddressError.email">{{ emailAddressError.email.message }}</small>
          </div>
        </form>
      </div>
      <div class="row justify-content-center">
        <div class="form-group col-md-12 text-center">

          <button v-if="emailAddressPending || emailAddressesPending" class="btn btn-primary disabled" disabled="disabled"><i class="fa fa-spinner fa-pulse fa-fw"></i> Čekám</button>
          <button v-else="" @click="nextStep" class="btn btn-primary" data-testid="registration-email-next">Další krok <i class="fa fa-arrow-right"></i></button>
        </div>
      </div>

      <div  v-if="waitForData" class="row justify-content-around">
        <div class="">
          <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import auth from '../../auth'
  // import error from '../../error'

  export default {
    data () {
      return {
        // emial address
        emailAddressError: {},
        emailAddressPending: false,
        emailAddress: {
          email: '',
          default: true,
          note: ''
        },
        // email addresses
        emailAddressesPending: false,
        emailAddresses: [],
        emailAddressesError: {},
        // client
        clientError: '',
        client: '',
        // others
        setting: require('../../../variables.js'),
        clientid: '',
        waitForResponse: false,
        waitForData: false,
        decodePinPending: false,
        message: '',
        submited: '',
        countries: [],
        citizenship: [],
        healthinsurance: [],
        pinDecodeError: []
      }
    },
    methods: {
      submitForm () {
        this.postEmailAddress()
      },
      nextStep () {
        this.$emit('completed-step', 3)
      },
      getEmailAddresses () {
        this.emailAddressesPending = true
        this.$http.get(this.setting.hostname + 'client/' + this.$route.params.clientid + '/email_address').then(response => {
          this.emailAddresses = response.data
          this.emailAddressesPending = false
        }).catch(error => {
          this.emailAddressesError = error.response.data.errors
          this.emailAddressesPending = false
        })
      },
      postEmailAddress () {
        this.emailAddressPending = true
        this.$http.post(this.setting.hostname + 'client/' + this.$route.params.clientid + '/email_address', this.emailAddress, {emulateJSON: true}).then(response => {
          this.submited = response.data
          this.emailAddressPending = false
          this.getEmailAddresses()
        }).catch(error => {
          this.emailAddressError = error.response.data.errors
          this.emailAddressPending = false
        })
      },
      getClient () {
        this.waitForData = true
        this.$http.get(this.setting.hostname + 'client/' + this.$route.params.clientid).then(response => {
          this.client = response.data
          this.waitForData = false
          if (this.client.health_insurance !== null) {
            this.$emit('completed-step', 2)
          }
        }).catch(error => {
          this.clientError = error.response.data.errors
          this.waitForData = false
        })
      }
    },
    beforeMount () {
      this.getEmailAddresses()
    },
    watch: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .icon-male {
    color: dodgerblue;
    font-weight: bold;
  }

  .icon-female {
    color: deeppink;
    font-weight: bold;
  }

  .icon-genderless {
    color: #ccc;
    font-weight: bold;
  }

  .table > tbody > tr > td, .table > tfoot > tr > td {
    vertical-align: middle;
  }

  .table > tbody > tr > td, .table > tfoot > tr > td {
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/views/Registration/components/RegistrationClientEmail.vue?45ba119b